<template>
  <div class="app-content">
    <div
      v-for="tab in this.tabs"
      :key="tab.id + '-component'"
      style="position: relative; top: 0px;"
    >
      <transition name="fade">
        <component :is="tab.component" v-bind="tab.props" v-if="tab.isActive" />
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';
import SubNavigationItem from '@/views/components/header/SubNavigationItem.vue';
import EmployeesIndex from '@/views/components/employees/EmployeesIndex.vue';
import NewEmployee from '@/views/components/employee-new/NewEmployee.vue';
import EmployeeDetails from '@/views/components/employee-details/EmployeeDetails.vue';
import ProcessDates from '@/resources/constants/process-dates';

export default {
  name: 'Employees',
  components: {
    Button,
    SubNavigationItem,
    EmployeesIndex,
    EmployeeDetails,
    NewEmployee
  },
  computed: {
    ...mapGetters({
      tabs: 'employeesTabs'
    })
  },
  mounted () {
    // TO-DO: rework when implementing login. For now load all employer policies when App mounts.
    // this.$store.dispatch(Policies.Actions.LoadAll.START);
    this.loadProcessDates();
  },
  methods: {
    ...mapActions({
      loadProcessDates: ProcessDates.Actions.IsProcessing.START
    })
  }
};
</script>

<style lang="scss" scoped>
</style>
